import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteBookingsService = async (bookingId: string): Promise<void> => {
  await wbsBookingsApi.delete(`/bookings/${bookingId}`);
};

export default deleteBookingsService;
